module.exports = {
      id: "close-usage",
      viewBox: "0 0 14 14.001",
      url: "/" + "svg-sprite-21c17c4d458cf2e2be6dd4c01f9ab03b.svg#close",
      toString: function () {
        return this.url;
      }
    }